var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import { DivTag } from '../../Utils/AtomicTag';
import { atomicMapSlider } from './atomicMap';
import Tooltip from '../Tooltip';
var Handler = /** @class */ (function (_super) {
    __extends(Handler, _super);
    function Handler(props) {
        var _this = _super.call(this, props) || this;
        _this.setHandleRef = function (node) {
            _this.handler = node;
        };
        _this.handler = null;
        return _this;
    }
    Handler.prototype.render = function () {
        var _a, _b;
        var _c = this.props, direction = _c.direction, reverse = _c.reverse, offset = _c.offset, style = _c.style, rest = __rest(_c, ["direction", "reverse", "offset", "style"]);
        var positionStyle = direction
            ? (_a = {},
                _a[reverse ? 'top' : 'bottom'] = offset + "%",
                _a[reverse ? 'bottom' : 'top'] = 'auto',
                _a.transform = reverse ? undefined : "translateY(+50%)",
                _a) : (_b = {},
            _b[reverse ? 'right' : 'left'] = offset + "%",
            _b[reverse ? 'left' : 'right'] = 'auto',
            _b.transform = "translateX(" + (reverse ? '+' : '-') + "50%)",
            _b);
        var margin = direction ? { marginLeft: '-3px' } : { marginTop: '-3px' };
        var elStyle = __assign(__assign({}, positionStyle), margin);
        return (React.createElement(DivTag, __assign({ atomics: atomicMapSlider.handlerStyle, style: elStyle, ref: this.setHandleRef }, rest)));
    };
    return Handler;
}(PureComponent));
var handler = function (props, ref) {
    var value = props.value, visible = props.visible, index = props.index, handle = props.handle, showLabel = props.showLabel, rest = __rest(props, ["value", "visible", "index", "handle", "showLabel"]);
    if (handle) {
        return (React.createElement(Tooltip, { title: value, visible: visible, showLabel: showLabel, placement: "Top", trigger: "hover", style: {} }, handle));
    }
    return (React.createElement(Tooltip, { title: value, visible: visible, showLabel: showLabel, placement: "Top", trigger: "hover", style: {} },
        React.createElement(Handler, __assign({ value: value, ref: ref, index: index }, rest))));
};
export default React.forwardRef(handler);
